import { Box, Grid2, IconButton, Slide, Tooltip } from "@mui/material"
import MaterialTypography from "../../../../components/MaterialTypography"
import MaterialBox from "../../../../components/MaterialBox"
import { AddHomeWork, Close, EventBusy, EventRepeat, WorkHistory } from "@mui/icons-material"
import './index.css'

const CustomDialogBox = ({
    open,
    onClose,
    handleOpenLeave,
    handleOpenRegularization,
    handleOpenWfh,
    handleOpenPermission,
    isLeaveApproved = false,
    isPermissionApproved = false,    
}) => {
    return (
        <>
            {open && (
                <>
                    {/* BackGround */}
                    <Box
                        onClick={onClose}
                        sx={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            bgcolor: "rgba(0, 0, 0, 0.59)",
                            zIndex: 2,
                        }}
                    />
                </>
            )}

            {/* Slide Effect */}
            <Slide
                timeout={800}
                direction="right"
                in={open}
                mountOnEnter unmountOnExit>

                {/* Dialog Box */}
                <Box className="custom-dialog-box">
                    {/* Dialog Content */}
                    <Box
                        justifyContent="space-between"
                        alignItems="center"
                        flexDirection="column"
                        p={3}
                    >
                        <Grid2 container spacing={2}>
                            {/* Heading */}
                            <Grid2 size={{ xs: 11 }}>
                                <MaterialBox>
                                    <MaterialTypography variant="h4">
                                        Select your Action
                                    </MaterialTypography>
                                </MaterialBox>
                            </Grid2>
                            {/* Close Icon */}
                            <Grid2 size={{ xs: 1 }}>
                                <IconButton
                                    onClick={onClose}
                                >
                                    <Tooltip title="Close" disableInteractive enterDelay={1200}>
                                        <Close fontSize="medium" />
                                    </Tooltip>
                                </IconButton>
                            </Grid2>
                            {/* Apply Leave Box */}
                            {!isLeaveApproved && (
                                <Grid2 size={{ lg: 6, md: 6, sm: 6, xs: 12 }}>
                                    <MaterialBox className="calendar-container">
                                        <MaterialBox
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            onClick={handleOpenLeave}
                                            className="calendar-action-box"
                                        >
                                            <Grid2 container direction="column">
                                                <Grid2 size={{ xs: 12, lg: 12 }}
                                                    sx={{
                                                        height: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>

                                                    {/* Icon */}
                                                    <MaterialBox display="flex" className="icon" mb={1}>
                                                        <EventBusy fontSize="large" />
                                                    </MaterialBox>

                                                </Grid2>
                                                <Grid2 size={{ xs: 12, lg: 12 }}
                                                    sx={{
                                                        height: "30%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>

                                                    {/* Title */}
                                                    <MaterialTypography
                                                        variant="body2"
                                                        fontWeight="bold"
                                                        align="center"
                                                    >
                                                        Apply Leave
                                                    </MaterialTypography>
                                                </Grid2>
                                                <Grid2 size={{ xs: 12, lg: 12 }}
                                                    sx={{
                                                        height: "20%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    {/* Description */}
                                                    <MaterialTypography
                                                        component="label"
                                                        variant="caption"
                                                        align="center"
                                                        sx={{ mt: 0.5 }}
                                                    >
                                                        You can apply for Leave here
                                                    </MaterialTypography>
                                                </Grid2>
                                            </Grid2>
                                        </MaterialBox>
                                    </MaterialBox>
                                </Grid2>
                            )}
                            {/* Regularization Box */}
                            <Grid2 size={{ lg: 6, md: 6, sm: 6, xs: 12 }}>
                                <MaterialBox className="calendar-container">
                                    <MaterialBox
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                        onClick={handleOpenRegularization}
                                        className="calendar-action-box"
                                    >
                                        <Grid2 container direction="column">
                                            <Grid2 size={{ xs: 12, lg: 12 }}
                                                sx={{
                                                    height: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                {/* Content Icon */}
                                                <MaterialBox display="flex" className="icon">
                                                    <EventRepeat fontSize="large" />
                                                </MaterialBox>
                                            </Grid2>
                                            <Grid2 size={{ xs: 12, lg: 12 }}
                                                sx={{
                                                    height: "30%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                {/* Content Title */}
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    mb={1}
                                                >
                                                    Regularization
                                                </MaterialTypography>
                                            </Grid2>
                                            <Grid2 size={{ xs: 12, lg: 12 }}
                                                sx={{
                                                    height: "20%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    p:"1px"
                                                }}>
                                                {/* Description */}
                                                <MaterialTypography
                                                    component="label"
                                                    variant="caption"
                                                    align="center"
                                                    sx={{ mt: 0.5 }}
                                                >
                                                    You can Regularize your missed attendance here
                                                </MaterialTypography>
                                            </Grid2>
                                        </Grid2>
                                    </MaterialBox>
                                </MaterialBox>
                            </Grid2>
                            {/* Work From Home Box */}
                            <Grid2 size={{ lg: 6, md: 6, sm: 6, xs: 12 }}>
                                <MaterialBox className="calendar-container">
                                    <MaterialBox
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                        onClick={handleOpenWfh}
                                        className="calendar-action-box"
                                    >
                                        <Grid2 container direction="column">
                                            <Grid2 size={{ xs: 12, lg: 12 }}
                                                sx={{
                                                    height: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                {/* Content Icon */}
                                                <MaterialBox className="icon" ml={1}>
                                                    <AddHomeWork fontSize="large" />
                                                </MaterialBox>
                                            </Grid2>
                                            {/* Content Title */}
                                            <Grid2 size={{ xs: 12, lg: 12 }}
                                                sx={{
                                                    height: "30%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                <MaterialBox ml={2}>
                                                    <MaterialTypography
                                                        variant="body2"
                                                        fontWeight="bold"
                                                    >
                                                        Work From Home
                                                    </MaterialTypography>
                                                </MaterialBox>
                                            </Grid2>
                                            <Grid2 size={{ xs: 12, lg: 12 }}
                                                sx={{
                                                    height: "20%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                {/* Description */}
                                                <MaterialTypography
                                                    component="label"
                                                    variant="caption"
                                                    align="center"
                                                    sx={{ mt: 0.5 }}
                                                >
                                                    You can apply for WFH here
                                                </MaterialTypography>
                                            </Grid2>
                                        </Grid2>
                                    </MaterialBox>
                                </MaterialBox>
                            </Grid2>
                            {/* Permission */}
                            {!isPermissionApproved && (
                                <Grid2 size={{ lg: 6, md: 6, sm: 6, xs: 12 }}>
                                    <MaterialBox className="calendar-container">
                                        <MaterialBox
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            onClick={handleOpenPermission}
                                            className="calendar-action-box"
                                        >
                                            <Grid2 container direction="column">
                                                <Grid2 size={{ xs: 12, lg: 12 }}
                                                    sx={{
                                                        height: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    {/* Content Icon */}
                                                    <MaterialBox className="icon" ml={1}>
                                                        <WorkHistory fontSize="large" />
                                                    </MaterialBox>
                                                </Grid2>
                                                <Grid2 size={{ xs: 12, lg: 12 }}
                                                    sx={{
                                                        height: "30%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    {/* Content Title */}
                                                    <MaterialBox ml={2}>
                                                        <MaterialTypography
                                                            variant="body2"
                                                            fontWeight="bold"
                                                        >
                                                            Permission
                                                        </MaterialTypography>
                                                    </MaterialBox>
                                                </Grid2>
                                                <Grid2 size={{ xs: 12, lg: 12 }}
                                                    sx={{
                                                        height: "20%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    {/* Description */}
                                                    <MaterialTypography
                                                        component="label"
                                                        variant="caption"
                                                        align="center"
                                                        sx={{ mt: 0.5 }}
                                                    >
                                                        You can apply for Permission here
                                                    </MaterialTypography>
                                                </Grid2>
                                            </Grid2>

                                        </MaterialBox>
                                    </MaterialBox>
                                </Grid2>
                            )}
                        </Grid2>
                    </Box>
                </Box>
            </Slide>
        </>
    )
}

export default CustomDialogBox